module.exports = "/lucky-balls/img/bonus_green/check_infoBar/check_015.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/check_infoBar/check_015.png
// module id = 938
// module chunks = 0